/** Dev-only fixtures for GameDetailModal preview — mirrors GET /api/games shape. */

const baseTeams = {
  oregon: {
    id: 2483,
    name: 'Oregon',
    abbreviation: 'ORE',
    conference: 'Big Ten',
    rank: 3,
    record: '10-1',
    classification: 'fbs',
    color: '#007030',
    alternate_color: '#FEE123',
    logos: ['https://a.espncdn.com/i/teamlogos/ncaa/500/2483.png'],
    mascot: 'Ducks',
  },
  michigan: {
    id: 130,
    name: 'Michigan',
    abbreviation: 'MICH',
    conference: 'Big Ten',
    rank: 5,
    record: '9-2',
    classification: 'fbs',
    color: '#00274C',
    alternate_color: '#FFCB05',
    logos: ['https://a.espncdn.com/i/teamlogos/ncaa/500/130.png'],
    mascot: 'Wolverines',
  },
};

const baseVenue = {
  name: 'Autzen Stadium',
  city: 'Eugene',
  state: 'OR',
  capacity: 54000,
  grass: true,
  dome: false,
  elevation: 420,
};

const baseWeather = {
  temperature: 58,
  wind_direction: 225,
  wind_speed: 8,
  condition: 'Partly Cloudy',
  game_indoors: false,
  dew_point: 45,
  humidity: 62,
  precipitation: 0,
  snowfall: 0,
  pressure: 30.12,
  forecast_refreshed_at: '2024-11-15T18:00:00.000Z',
};

const baseBetting = {
  spread: -3.5,
  over_under: 52.5,
  spread_open: -2.5,
  over_under_open: 54,
  home_moneyline: -165,
  away_moneyline: 140,
};

/** Multi-point Bovada progression for Lines tab preview (includes a favorite flip). */
export const MOCK_LINE_HISTORY = {
  gameId: 99001,
  synthetic: false,
  points: [
    {
      capturedAt: '2024-11-10T16:00:00.000Z',
      spread: -2.5,
      overUnder: 54,
      source: 'open',
    },
    {
      capturedAt: '2024-11-11T18:00:00.000Z',
      spread: -1,
      overUnder: 53.5,
      source: 'lines_api',
    },
    {
      capturedAt: '2024-11-12T20:00:00.000Z',
      spread: 1.5,
      overUnder: 52,
      source: 'lines_api',
    },
    {
      capturedAt: '2024-11-13T22:00:00.000Z',
      spread: -2,
      overUnder: 51.5,
      source: 'lines_api',
    },
    {
      capturedAt: '2024-11-15T08:00:00.000Z',
      spread: -4,
      overUnder: 52,
      source: 'lines_api',
    },
    {
      capturedAt: '2024-11-16T14:00:00.000Z',
      spread: -3.5,
      overUnder: 52.5,
      source: 'lines_api',
    },
  ],
};

/** Live-game history ends mid-week with a late steam. */
export const MOCK_LINE_HISTORY_LIVE = {
  gameId: 99002,
  synthetic: false,
  points: [
    ...MOCK_LINE_HISTORY.points.slice(0, 5),
    {
      capturedAt: '2024-11-16T19:30:00.000Z',
      spread: -4,
      overUnder: 51.5,
      source: 'scoreboard',
    },
  ],
};

const shared = {
  season: 2024,
  week: 12,
  season_type: 'regular',
  start_date: '2024-11-16T20:00:00.000Z',
  start_time_tbd: false,
  away_team: baseTeams.michigan,
  home_team: baseTeams.oregon,
  venue: baseVenue,
  weather: baseWeather,
  betting: baseBetting,
  neutral_site: false,
  conference_game: true,
  tv: 'ABC',
  home_pregame_elo: 1985,
  away_pregame_elo: 1962,
  excitement_index: 7.8,
  has_user_pick: false,
};

export const MOCK_SCHEDULED_GAME = {
  ...shared,
  id: 99001,
  game_status: 'scheduled',
  notes: null,
  home_score: null,
  away_score: null,
  home_line_scores: null,
  away_line_scores: null,
  home_postgame_elo: null,
  away_postgame_elo: null,
  attendance: null,
  highlights: null,
  period: null,
  clock: null,
  situation: null,
  possession: null,
  last_play: null,
};

export const MOCK_LIVE_GAME = {
  ...shared,
  id: 99002,
  game_status: 'in_progress',
  home_score: 31,
  away_score: 24,
  home_line_scores: [7, 14, 3, 7],
  away_line_scores: [10, 0, 7, 7],
  home_postgame_elo: null,
  away_postgame_elo: null,
  attendance: null,
  highlights: null,
  period: '4',
  clock: '7:42',
  situation: '2nd & 7 at ORE 38',
  possession: 'home',
  last_play: 'Henderson rush for 4 yards to the ORE 38',
  betting: {
    ...baseBetting,
    spread: -4,
    over_under: 51.5,
  },
};

export const MOCK_COMPLETED_GAME = {
  ...shared,
  id: 99003,
  game_status: 'completed',
  home_score: 31,
  away_score: 24,
  home_line_scores: [7, 14, 3, 7],
  away_line_scores: [10, 0, 7, 7],
  home_postgame_elo: 1998,
  away_postgame_elo: 1948,
  attendance: 54136,
  highlights: null,
  period: '4',
  clock: '00:00',
  situation: null,
  possession: null,
  last_play: 'Game complete',
  excitement_index: 8.4,
};

/** Sample league locks for previewing the Locks tab. */
export const MOCK_PREVIEW_LOCKS = {
  live: [
    { userId: 1, username: 'testuser', pickType: 'home', lockLine: -3.5, status: 'locked', won_lost: null, gameId: 99002 },
    { userId: 2, username: 'alice', pickType: 'away', lockLine: 3.5, status: 'locked', won_lost: null, gameId: 99002 },
    { userId: 3, username: 'bob', pickType: 'over', lockLine: 52.5, status: 'locked', won_lost: null, gameId: 99002 },
    { userId: 4, username: 'carol', pickType: 'under', lockLine: 52.5, status: 'locked', won_lost: null, gameId: 99002 },
  ],
  completed: [
    { userId: 1, username: 'testuser', pickType: 'home', lockLine: -3.5, status: 'locked', won_lost: 'won', gameId: 99003 },
    { userId: 2, username: 'alice', pickType: 'away', lockLine: 3.5, status: 'locked', won_lost: 'lost', gameId: 99003 },
    { userId: 3, username: 'bob', pickType: 'over', lockLine: 52.5, status: 'locked', won_lost: 'won', gameId: 99003 },
    { userId: 4, username: 'carol', pickType: 'under', lockLine: 52.5, status: 'locked', won_lost: 'lost', gameId: 99003 },
  ],
};

const sampleLogEntry = (overrides) => ({
  gameId: 90001,
  startDate: '2024-10-12T19:00:00Z',
  isHome: false,
  opponent: 'PSU',
  opponentName: 'Penn State',
  score: '24-28',
  wl: 'loss',
  ats: 'win',
  ou: 'over',
  spreadLine: '+3.5',
  totalLine: '47.5',
  ...overrides,
});

/** Dev preview for season game log + CORE on Overview. */
export const MOCK_MATCHUP_STATS = {
  gameId: 99001,
  season: 2024,
  awayTeam: {
    teamId: baseTeams.michigan.id,
    core: {
      offense: 6.2,
      defense: -3.8,
      overall: 10.0,
      offensivePlays: 720,
      defensivePlays: 710,
      weekThrough: 11,
      modelVersion: 'core-v1',
    },
    seasonLog: {
      entries: [
        sampleLogEntry({ gameId: 90011, opponent: 'OSU', score: '17-21', wl: 'loss', ats: 'loss', ou: 'under', spreadLine: '+4', totalLine: '44.5', startDate: '2024-11-09T19:00:00Z' }),
        sampleLogEntry({ gameId: 90010, opponent: 'MSU', isHome: true, score: '31-10', wl: 'win', ats: 'win', ou: 'over', spreadLine: '-14', totalLine: '46.5', startDate: '2024-11-02T19:00:00Z' }),
        sampleLogEntry({ gameId: 90009, opponent: 'WASH', isHome: true, score: '27-20', wl: 'win', ats: 'loss', ou: 'over', spreadLine: '-7.5', totalLine: '42.5', startDate: '2024-10-26T19:00:00Z' }),
        sampleLogEntry({ gameId: 90008, opponent: 'RUTG', isHome: false, score: '28-14', wl: 'win', ats: 'win', ou: 'under', spreadLine: '-10', totalLine: '48.5', startDate: '2024-10-19T19:00:00Z' }),
        sampleLogEntry({ gameId: 90007, opponent: 'NW', isHome: true, score: '35-17', wl: 'win', ats: 'win', ou: 'over', spreadLine: '-21', totalLine: '44.5', startDate: '2024-10-12T19:00:00Z' }),
        sampleLogEntry({ gameId: 90006, opponent: 'PSU', isHome: false, score: '21-24', wl: 'loss', ats: 'win', ou: 'under', spreadLine: '+3', totalLine: '47.5', startDate: '2024-10-05T19:00:00Z' }),
        sampleLogEntry({ gameId: 90005, opponent: 'MINN', isHome: true, score: '42-10', wl: 'win', ats: 'win', ou: 'over', spreadLine: '-18.5', totalLine: '43.5', startDate: '2024-09-28T19:00:00Z' }),
      ],
      totalCount: 7,
      hasMore: true,
      summary: {
        wl: { wins: 5, losses: 2, pushes: 0, total: 7 },
        ats: { wins: 5, losses: 2, pushes: 0, total: 7 },
        ou: { overs: 4, unders: 3, pushes: 0, total: 7 },
      },
      previewSummary: {
        wl: { wins: 2, losses: 1, pushes: 0, total: 3 },
        ats: { wins: 1, losses: 2, pushes: 0, total: 3 },
        ou: { overs: 2, unders: 1, pushes: 0, total: 3 },
      },
    },
  },
  homeTeam: {
    teamId: baseTeams.oregon.id,
    core: {
      offense: 8.4,
      defense: -5.1,
      overall: 13.5,
      offensivePlays: 735,
      defensivePlays: 698,
      weekThrough: 11,
      modelVersion: 'core-v1',
    },
    seasonLog: {
      entries: [
        sampleLogEntry({ gameId: 90021, opponent: 'USC', isHome: true, score: '35-28', wl: 'win', ats: 'win', ou: 'over', spreadLine: '-6.5', totalLine: '55.5', startDate: '2024-11-09T20:00:00Z' }),
        sampleLogEntry({ gameId: 90020, opponent: 'UCLA', isHome: false, score: '21-14', wl: 'win', ats: 'win', ou: 'under', spreadLine: '-10.5', totalLine: '52.5', startDate: '2024-11-02T23:00:00Z' }),
        sampleLogEntry({ gameId: 90019, opponent: 'WIS', isHome: true, score: '28-24', wl: 'win', ats: 'loss', ou: 'over', spreadLine: '-9', totalLine: '44.5', startDate: '2024-10-26T19:00:00Z' }),
      ],
      summary: {
        wl: { wins: 3, losses: 0, pushes: 0, total: 3 },
        ats: { wins: 2, losses: 1, pushes: 0, total: 3 },
        ou: { overs: 2, unders: 1, pushes: 0, total: 3 },
      },
    },
  },
  splits: {
    spread: [
      {
        key: 'all',
        category: 'ALL',
        away: { label: 'ALL GAMES', wins: 5, losses: 2, pushes: 0, total: 7, pct: 71, recordLabel: '5-2' },
        home: { label: 'ALL GAMES', wins: 2, losses: 1, pushes: 0, total: 3, pct: 67, recordLabel: '2-1' },
      },
      {
        key: 'location',
        category: 'LOCATION',
        away: { label: 'ON ROAD OR NEUTRAL', wins: 2, losses: 1, pushes: 0, total: 3, pct: 67, recordLabel: '2-1' },
        home: { label: 'AT HOME', wins: 1, losses: 1, pushes: 0, total: 2, pct: 50, recordLabel: '1-1' },
      },
      {
        key: 'status',
        category: 'STATUS',
        away: { label: 'AS UNDERDOG OR PK', wins: 1, losses: 1, pushes: 0, total: 2, pct: 50, recordLabel: '1-1' },
        home: { label: 'AS FAVORITE', wins: 2, losses: 1, pushes: 0, total: 3, pct: 67, recordLabel: '2-1' },
      },
      {
        key: 'spread',
        category: 'SPREAD',
        away: { label: 'WHEN SPREAD WAS +1.5 TO +5.5', wins: 1, losses: 0, pushes: 0, total: 1, pct: 100, recordLabel: '1-0' },
        home: { label: 'WHEN SPREAD WAS -5.5 TO -1.5', wins: 1, losses: 0, pushes: 0, total: 1, pct: 100, recordLabel: '1-0' },
      },
      {
        key: 'location_status',
        category: 'LOCATION & STATUS',
        away: { label: 'AS ROAD UNDERDOG', wins: 1, losses: 1, pushes: 0, total: 2, pct: 50, recordLabel: '1-1' },
        home: { label: 'FAVORED AT HOME', wins: 1, losses: 1, pushes: 0, total: 2, pct: 50, recordLabel: '1-1' },
      },
      {
        key: 'opp_win_pct',
        category: 'OPP WIN%',
        away: { label: 'VS TEAMS WINNING 55% TO 75%', wins: 2, losses: 1, pushes: 0, total: 3, pct: 67, recordLabel: '2-1' },
        home: { label: 'VS TEAMS WINNING 60% TO 80%', wins: 1, losses: 1, pushes: 0, total: 2, pct: 50, recordLabel: '1-1' },
      },
      {
        key: 'opp_defense',
        category: 'OPP DEFENSE',
        away: { label: 'VS DEFENSE RATED 8.0 TO 18.0', wins: 1, losses: 1, pushes: 0, total: 2, pct: 50, recordLabel: '1-1' },
        home: { label: 'VS DEFENSE RATED 10.5 TO 20.5', wins: 2, losses: 0, pushes: 0, total: 2, pct: 100, recordLabel: '2-0' },
      },
      {
        key: 'rest',
        category: 'REST',
        away: { label: 'STANDARD REST', wins: 3, losses: 1, pushes: 0, total: 4, pct: 75, recordLabel: '3-1' },
        home: { label: 'STANDARD REST', wins: 2, losses: 0, pushes: 0, total: 2, pct: 100, recordLabel: '2-0' },
      },
      {
        key: 'h2h',
        category: 'HEAD TO HEAD',
        away: { label: 'VS ORE', wins: 0, losses: 0, pushes: 0, total: 0, pct: null, recordLabel: '0-0' },
        home: { label: 'VS MICH', wins: 0, losses: 0, pushes: 0, total: 0, pct: null, recordLabel: '0-0' },
      },
    ],
    overUnder: [
      {
        key: 'all',
        category: 'ALL',
        away: { label: 'ALL GAMES', wins: 4, losses: 3, pushes: 0, total: 7, pct: 57, recordLabel: '4-3' },
        home: { label: 'ALL GAMES', wins: 2, losses: 1, pushes: 0, total: 3, pct: 67, recordLabel: '2-1' },
      },
      {
        key: 'location',
        category: 'LOCATION',
        away: { label: 'ON ROAD OR NEUTRAL', wins: 1, losses: 2, pushes: 0, total: 3, pct: 33, recordLabel: '1-2' },
        home: { label: 'AT HOME', wins: 2, losses: 0, pushes: 0, total: 2, pct: 100, recordLabel: '2-0' },
      },
      {
        key: 'line',
        category: 'LINE',
        away: { label: 'WHEN LINE IS ≥50', wins: 1, losses: 1, pushes: 0, total: 2, pct: 50, recordLabel: '1-1' },
        home: { label: 'WHEN LINE IS ≥50', wins: 1, losses: 1, pushes: 0, total: 2, pct: 50, recordLabel: '1-1' },
      },
      {
        key: 'similar_line',
        category: 'SIMILAR LINE',
        away: { label: 'WHEN LINE WAS 50.5 TO 54.5', wins: 1, losses: 1, pushes: 0, total: 2, pct: 50, recordLabel: '1-1' },
        home: { label: 'WHEN LINE WAS 50.5 TO 54.5', wins: 1, losses: 1, pushes: 0, total: 2, pct: 50, recordLabel: '1-1' },
      },
      {
        key: 'opp_offense',
        category: 'OPP OFFENSE',
        away: { label: 'VS OFFENSE RATED 15.0 TO 25.0', wins: 2, losses: 1, pushes: 0, total: 3, pct: 67, recordLabel: '2-1' },
        home: { label: 'VS OFFENSE RATED 12.0 TO 22.0', wins: 1, losses: 1, pushes: 0, total: 2, pct: 50, recordLabel: '1-1' },
      },
      {
        key: 'opp_defense',
        category: 'OPP DEFENSE',
        away: { label: 'VS DEFENSE RATED 8.0 TO 18.0', wins: 1, losses: 2, pushes: 0, total: 3, pct: 33, recordLabel: '1-2' },
        home: { label: 'VS DEFENSE RATED 10.5 TO 20.5', wins: 1, losses: 0, pushes: 0, total: 1, pct: 100, recordLabel: '1-0' },
      },
      {
        key: 'location_line',
        category: 'LOCATION AND LINE',
        away: { label: 'ON ROAD OR NEUTRAL', wins: 0, losses: 1, pushes: 0, total: 1, pct: 0, recordLabel: '0-1' },
        home: { label: 'AT HOME', wins: 1, losses: 0, pushes: 0, total: 1, pct: 100, recordLabel: '1-0' },
      },
      {
        key: 'rest',
        category: 'REST',
        away: { label: 'STANDARD REST', wins: 2, losses: 2, pushes: 0, total: 4, pct: 50, recordLabel: '2-2' },
        home: { label: 'STANDARD REST', wins: 1, losses: 1, pushes: 0, total: 2, pct: 50, recordLabel: '1-1' },
      },
      {
        key: 'h2h',
        category: 'HEAD TO HEAD',
        away: { label: 'VS ORE', wins: 0, losses: 0, pushes: 0, total: 0, pct: null, recordLabel: '0-0' },
        home: { label: 'VS MICH', wins: 0, losses: 0, pushes: 0, total: 0, pct: null, recordLabel: '0-0' },
      },
    ],
  },
};

export const GAME_DETAIL_PREVIEW_SCENARIOS = [
  {
    id: 'scheduled',
    label: 'Scheduled',
    description: 'Pre-kickoff — pick grid active, empty box score, browse mode.',
    game: MOCK_SCHEDULED_GAME,
    initialSelectedPick: null,
    previewLocks: null,
  },
  {
    id: 'scheduled-pick',
    label: 'Scheduled (line pre-selected)',
    description: 'Opens with Oregon spread selected — Watch/Lock ready.',
    game: MOCK_SCHEDULED_GAME,
    initialSelectedPick: 'home',
    previewLocks: null,
  },
  {
    id: 'live',
    label: 'Live (Q4)',
    description: 'Live strip, scores, box score, in-progress lock margins.',
    game: MOCK_LIVE_GAME,
    initialSelectedPick: null,
    previewLocks: MOCK_PREVIEW_LOCKS.live,
  },
  {
    id: 'completed',
    label: 'Final',
    description: 'Final score, attendance, won/lost on league locks.',
    game: MOCK_COMPLETED_GAME,
    initialSelectedPick: null,
    previewLocks: MOCK_PREVIEW_LOCKS.completed,
  },
];
